import ReactGA from 'react-ga';

const addCurrentUrltoGA = () => {
  const currentUrl = window.location.pathname + window.location.hash;
  ReactGA.pageview(currentUrl);
};

const initialGA = () => {
  ReactGA.initialize('UA-71731309-3');
};

export { addCurrentUrltoGA, initialGA };
